import styled, { css } from 'styled-components'
import { ButtonBack, ButtonNext, CarouselProvider, Dot, Slider } from 'pure-react-carousel'
import { tabletBreakpoint, desktopBreakpoint } from 'react-components'

export const CarouselContainer = styled.div<CarouselProps>(
    ({ theme, imageCarouselBorderRadius, horizontalCardHeight, margin }) => css`
        height: ${!!horizontalCardHeight ? horizontalCardHeight : '100%'};
        position: ${theme.style.position.relative};
        border-radius: ${!!imageCarouselBorderRadius ? imageCarouselBorderRadius : `0.375rem 0.375rem 0 0`};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            margin-right: ${theme.spacing.medium};
        }
        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            margin-right: 1.125rem;
        }
        ${!!margin && `margin: ${margin} !important`};
    `,
)

type CarouselProps = {
    imageCarouselBorderRadius?: string
    horizontalCardHeight?: string
    margin?: string
}

export const CarouselImage = styled.div<CarouselProps>(
    ({ theme, horizontalCardHeight }) => css`
        height: ${!!horizontalCardHeight ? horizontalCardHeight : '100%'};
        width: ${theme.layout.fill};
        position: ${theme.style.position.relative};
        overflow: hidden;
        border-radius: ${theme.typography.border.radius.xLarge} ${theme.typography.border.radius.xLarge} 0 0;
    `,
)

export const ImageContainer = styled.div`
    display: block;
`

export const SlidePlaceholder = styled.div<{ paddingTop?: string }>`
    padding-top: ${({ paddingTop }) => paddingTop ?? '0'};
`

export const StyledSlider = styled(Slider)<{ $transitionTime?: number }>(
    ({ $transitionTime }) => css`
        padding: 0;
        ul {
            transition: transform ${$transitionTime ? `${$transitionTime}s` : `0.5s`};
            transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
            will-change: transform;
        }
    `,
)

export const CarouselIcon = styled.img`
    height: 1rem;
    width: 1rem;
`

export const StyledCarouselBackButton = styled(ButtonBack)<{ $left?: boolean; $right?: boolean }>(
    ({ $left, $right, theme }) => css`
        position: ${theme.style.position.absolute};
        top: 45%;
        left: ${$left ? 0 : 'unset'};
        right: ${$right ? 0 : 'unset'};
        background-color: rgba(33, 33, 33, 0.6);
        box-shadow: 0px 5px 5px 0px #00000014, 0px 3px 14px 0px #0000000a, 0px 8px 10px 0px #0000000f;
        border-radius: 100%;
        margin: 0 1.25rem;
        height: 2rem;
        width: 2rem;
        display: flex;
        flex-direction: ${theme.style.flexDirection.column};
        align-items: ${theme.style.alignItems.center};
        justify-content: ${theme.style.justifyContent.center};
        opacity: 1;
        z-index: 10;

        svg path {
            stroke: white;
        }

        svg {
            min-width: 1.5rem;
            min-height: 1.5rem;
        }

        &:hover {
            opacity: 1 !important;
            transition: opacity 200ms ease-in;
        }
    `,
)

export const StyledCarouselNextButton = styled(StyledCarouselBackButton).attrs({ as: ButtonNext })``

export const StyledCarouselProvider = styled(CarouselProvider)`
    width: ${props => props.theme.layout.fill};
    li {
        list-style: none;
    }
`

export const StyledDotsContainer = styled.div<{ borderRadius?: string }>(
    ({ theme, borderRadius }) => css`
        position: absolute;
        justify-content: center;
        align-items: flex-end;
        width: ${theme.layout.fill};
        bottom: 0;
        display: flex;
        z-index: 10;
        border-radius: ${!!borderRadius ? borderRadius : 'unset'};
        pointer-events: none;
        padding-bottom: ${theme.spacing.medium};
    `,
)

export const FixedContainer = styled.div<{ justifyContent?: string }>(
    ({ justifyContent }) => css`
        margin-bottom: ${props => props.theme.spacing.small};
        align-items: center;
        display: flex;
        width: 50px;
        overflow: hidden;
        justify-content: ${justifyContent ? justifyContent : 'flex-start'};
        pointer-events: auto;
    `,
)

export const DotsOuterWrapper = styled.div<{ offset: string }>(
    ({ offset }) => css`
        display: flex;
        transform: translateX(${offset});
    `,
)

export const StyledDotWrapper = styled(Dot)``

export const StyledDot = styled.div<{ selected: boolean }>(
    ({ selected }) => css`
        height: 0.375rem;
        width: 0.375rem;
        background: #ffffff80;
        border-radius: 50%;
        margin-right: 0.25rem;
        ${selected
            ? `
            height: 0.5rem;
            width: 0.5rem;
            background: white;
        `
            : ''}
    `,
)
